(() => {
  const tagId = 'G-NK1L7YNP19';
  if (window.Shopify?.designMode || window.eliteAnalyticsInitialized) return;
  window.eliteAnalyticsInitialized = true;
  let configured = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  function syncConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    const allowed = privacy.analyticsProcessingAllowed();
    window['ga-disable-' + tagId] = !allowed;
    if (!configured && allowed) {
      window.gtag('consent', 'default', {
        analytics_storage: 'granted',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied'
      });
      window.gtag('js', new Date());
      window.gtag('config', tagId, {
        allow_google_signals: false,
        allow_ad_personalization_signals: false
      });
      configured = true;
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + tagId;
        document.head.appendChild(script);
      }
    } else if (configured) {
      window.gtag('consent', 'update', { analytics_storage: allowed ? 'granted' : 'denied' });
    }
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify?.customerPrivacy) {
    syncConsent();
  } else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) syncConsent();
    });
  }
})();
